import { isMobile } from 'react-device-detect';
import { modelView } from 'effector-factorio';
import { useGate, useUnit } from 'effector-react';

import { postTodoFx } from 'shared/api';
import { Box } from 'shared/ui/Box';
import { FormCategoryTitle } from 'shared/ui/FormComponents/FormCategoryTitle';
import { Spinner } from 'shared/ui/Spinner';
import { Flex } from 'shared/ui/StyledComponents';
import { Typography } from 'shared/ui/Typography';

import { getComponentByTodoType } from '../lib/getComponentByTodoType';
import { getCurrentTodosFx } from '../model/effects';
import { factory } from '../model/model';
import { PrevTodoList } from './PrevTodoList';

type Props = {
  isNeedTitle?: boolean;
};

export const TodoList = modelView(factory, ({ isNeedTitle }: Props) => {
  const model = factory.useModel();
  useGate(model.TodoListGate);
  const todos = useUnit(model.$todos);
  const completedTask = useUnit(model.$completedTask);

  const isPostEffectLoading = useUnit(postTodoFx.pending);
  const isCurrentTodosLoading = useUnit(getCurrentTodosFx.pending);

  return (
    <Box mt={isMobile ? 20 : 0}>
      {isNeedTitle && <FormCategoryTitle marginBottom={todos?.tasks.length ? 25 : 10}>Мои задачи</FormCategoryTitle>}
      {isCurrentTodosLoading ? (
        <Box mb={25}>
          <Spinner />
        </Box>
      ) : !todos?.tasks.length ? (
        <Typography fontSize={18} marginBottom={25}>
          Сейчас нет задач
        </Typography>
      ) : (
        <Flex flexDirection='column' gap={20} mb={25}>
          {todos?.tasks?.map((item, index) => {
            const isLoading = completedTask?.task_id === item.id.toString() && isPostEffectLoading;

            return <Box key={index}>{getComponentByTodoType({ item, isLoading })}</Box>;
          })}
        </Flex>
      )}
      <PrevTodoList />
    </Box>
  );
});
